.modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 2rem;

  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

@media (width < 500px) {
  .modal {
    width: 90%;
    padding: 1rem;
    gap: 1rem;
  }
}

.modal header {
  width: 100%;
  display: flex;
  justify-content: center;

  font-weight: bold;
  font-size: 2rem;
}

@media (width < 500px) {
  .modal header {
    font-size: 1.35rem;
  }
}

.backdrop {
  position: absolute;
  z-index: 1;
  inset: 0;
  backdrop-filter: blur(2px);
  width: 100vw;
  height: 100vh;
}

.modal button {
  padding: 0.75rem;

  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  background-color: black;
  border: 1px solid lightslategray;
  color: white;

  cursor: pointer;
}
